import { Component, ReactNode } from "react";

type Props = {
  fallback: ReactNode;
  children: ReactNode;
};

type State = {
  hasError: boolean;
};

/**
 * Shows `fallback` in place of a subtree that threw while rendering. React has
 * no hook for this, so it has to be a class.
 *
 * It does not report the error itself: React passes every error a boundary
 * catches to `console.error`, and Datadog RUM records that as an error.
 * Reporting it here too would count each one twice.
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
